import { FC, MouseEvent } from 'react';
import { Link } from '@mui/icons-material';
import cn from 'classnames';

import { LinkButtonProps } from './RichEditor.interface';

const LinkButton: FC<LinkButtonProps> = ({
  hasLinkSelected,
  onRemoveLinkAtSelection,
  onAddLinkClick,
  theme,
}) => {
  const className = cn(theme?.button, hasLinkSelected && theme?.active);

  return (
    <div
      className={theme?.buttonWrapper}
      onMouseDown={(event: MouseEvent): void => {
        event.preventDefault();
      }}
    >
      <button
        aria-label="Link"
        className={className}
        onClick={hasLinkSelected ? onRemoveLinkAtSelection : onAddLinkClick}
        type="button"
      >
        <Link />
      </button>
    </div>
  );
};

export default LinkButton;
